import styled from 'styled-components';
import { Typography } from '@interstate/components/Typography';

export const TableStyled = styled.div`
    /* Table header styles */
    .ant-table .ant-table-container .ant-table-content table thead.ant-table-thead .ant-table-cell {
        background-color: #f4f4f4 !important;
        color: #6d6d6d !important;
        border-bottom: 2px solid #b2b2b2 !important;
    }

    // provided default width for columns for desktop view
    .ant-table-thead tr {
        th {
            &.column-date-time {
                width: 100px;
            }

            &.column-source {
                width: 130px;
            }

            &.column-modifiedBy {
                width: 100px;
            }
            &.column-print-audit-log {
                width: 25px;
            }
        }
    }
    .ant-table-tbody tr {
        td {
            &.column-print-audit-log {
                padding-left: 0 !important;
            }
        }
    }

    // adding CSS for Tablet view
    @media (max-width: 952px) {
        .deal-version td {
            padding-left: 0 !important;
            padding-right: 0 !important;

            &.column-print-audit-log {
                padding-left: 0 !important;
                padding-right: 8px !important;
            }
        }

        .ant-table-thead tr th.ant-table-row-expand-icon-cell {
            padding-left: 0 !important;
            padding-right: 0 !important;
        }
        .ant-table-thead tr th.column-date-time {
            padding-left: 0 !important;
            padding-right: 0 !important;
            width: 70px !important;
        }
        .ant-table-thead tr th.deal-information-column {
            padding-left: 0 !important;
            padding-right: 0 !important;
        }
        .ant-table-thead tr th.column-source {
            padding-left: 0 !important;
            padding-right: 0 !important;
            width: 80px !important;
        }
        .ant-table-thead tr th.column-modifiedBy {
            padding-left: 0 !important;
            padding-right: 0 !important;
            width: 70px !important;
        }
        .ant-table-thead tr th.column-print-audit-log {
            padding-left: 0 !important;
            padding-right: 0 !important;
            width: 20px !important;
        }
    }

    & table tr th:nth-of-type(2),
    & table tr th:last-of-type {
        pointer-events: none;
        svg {
            display: none;
        }
    }
    cursor: pointer;

    /* Target first td in table with specific data-test-id */
    [data-testid='ids-table-audit-log-table'] {
        /* For expanded rows */
        .ant-table-row-expand-icon-cell:has([data-ids-react-component-name='ids-react-ChevronDownIcon']) {
            border-left: 4px solid #003468 !important;
        }
        .ant-table-expanded-row > td:first-child {
            border-left: 4px solid #003468;
        }
    }

    [data-testid='ids-table-change-log-table'] {
        /* For expanded rows */
        .ant-table-row-expand-icon-cell:has([data-ids-react-component-name='ids-react-ChevronDownIcon']) {
            border-left: none !important;
        }
        .ant-table-expanded-row > td:first-child {
            border-left: none !important;
        }
    }
`;

export const TimeStyled = styled(Typography)`
    text-transform: uppercase !important;
`;
